import { render } from "./matchingApply.vue?vue&type=template&id=53547c50&scoped=true"
import script from "./matchingApply.vue?vue&type=script&lang=js"
export * from "./matchingApply.vue?vue&type=script&lang=js"

import "./matchingApply.vue?vue&type=style&index=0&id=53547c50&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53547c50"],['__file',"src/views/exhibitionManage/matchingApply.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "53547c50"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('53547c50', __exports__)) {
    console.log('reload')
    api.reload('53547c50', __exports__)
  }
  
  module.hot.accept("./matchingApply.vue?vue&type=template&id=53547c50&scoped=true", () => {
    console.log('re-render')
    api.rerender('53547c50', render)
  })

}


export default __exports__